module.exports = __webpack_public_path__ + "img/table.93b51777.svg";